module.exports = __webpack_public_path__ + "static/img/logo.4ad3e935.png";